"use client";
import{a as y}from"./chunk-734RVJDY.js";import"./chunk-2D3SD5KA.js";import"./chunk-7APETSTL.js";import"./chunk-D5PYYGYB.js";import"./chunk-O6HTNRMG.js";import{E as c,G as f,J as w}from"./chunk-SJSRUEYQ.js";import"./chunk-L535NPP3.js";import{ApiError as u,verifyPaymentPassword as V}from"@particle-network/auth-core";import{useRequest as x}from"ahooks";import a,{useEffect as C,useState as k}from"react";import{useTranslation as _}from"react-i18next";var p=`.payment-password-drawer {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.payment-password-drawer .ant-drawer-body {
  padding-right: 0;
  padding-left: 0;
  overflow: hidden;
}
.payment-password-drawer .ant-drawer-content-wrapper {
  width: 100% !important;
}
.payment-password-drawer .ant-drawer-content .ant-drawer-wrapper-body .ant-drawer-header {
  display: none;
}
.payment-password-drawer .particle-pc-drawer .payment-verify-content {
  margin-top: 38px;
}
.payment-password-drawer .payment-verify-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  margin-top: 22px;
}
.payment-password-drawer .payment-verify-content .particle-keywords-map {
  position: absolute;
}
@media (min-width: 600px) {
  .payment-password-drawer {
    position: absolute;
  }
}
`;var A=({props:t})=>{let{setPaymentVerify:o,setWrongPassword:s}=w(),{t:n}=_(),[i,r]=k(""),{authCoreModal:g}=f();C(()=>{t.visible&&r("")},[t.visible]);let{loading:d,run:v}=x(V,{manual:!0,onSuccess:(e,l)=>{var m;o({visible:!1}),(m=t.onVerifyCompleted)==null||m.call(t,i)},onError:e=>{if(r(""),(e==null?void 0:e.error_code)===u.WrongPaymentPassword)s({visible:!0});else if((e==null?void 0:e.error_code)===u.SecurityAccountFrozen){let l=e.extra.seconds||0;s({visible:!0,accountFrozen:{seconds:l}})}}}),b=()=>{var e;if(d)return!1;o({visible:!1}),(e=t.onVerifyFailed)==null||e.call(t,n("common.cancel"))},h=e=>{r(e),e.length===6&&v(e)};return a.createElement(a.Fragment,null,a.createElement("style",null,p),a.createElement(c,{visible:t.visible,placement:"bottom",height:421,closable:!1,maskClosable:!1,onClose:b,className:"payment-password-drawer",title:t.type==="close"?n("account.close_payment_password"):n("account.payment_password"),forceRender:!0,getContainer:()=>g.rootBody},a.createElement("div",{className:"content payment-verify-content"},a.createElement(y,{onChange:h,value:i,keyboardInvisible:d}))))},T=A;export{T as default};
